import { useEffect } from 'react';
import {
  setBasicMetaTags,
  setOGPTags,
  setTwitterCardTags,
  setCanonicalUrl,
  clearMetaTags,
  type OGPMetaTags,
  type TwitterCardMetaTags,
  type BasicMetaTags,
} from '../utils/metaTags';

export interface UseMetaTagsOptions extends BasicMetaTags {
  ogp?: OGPMetaTags;
  twitterCard?: TwitterCardMetaTags;
  canonicalUrl?: string;
  keywords?: string;
}

/**
 * メタタグを管理するカスタムフック
 * コンポーネントのマウント時にメタタグを設定し、アンマウント時にクリーンアップ
 */
export const useMetaTags = (options: UseMetaTagsOptions): void => {
  const {
    title,
    description,
    ogp,
    twitterCard,
    canonicalUrl,
    keywords,
  } = options;

  useEffect(() => {
    // 基本メタタグを設定
    setBasicMetaTags({
      title,
      description,
      keywords,
    });

    // OGPタグを設定
    if (ogp) {
      setOGPTags(ogp);
    } else {
      // OGPが指定されていない場合は基本情報から生成
      setOGPTags({
        title,
        description,
        type: 'website',
      });
    }

    // Twitter Cardタグを設定
    if (twitterCard) {
      setTwitterCardTags(twitterCard);
    } else {
      // Twitter Cardが指定されていない場合は基本情報から生成
      setTwitterCardTags({
        title,
        description,
        card: 'summary_large_image',
      });
    }

    // Canonical URLを設定
    if (canonicalUrl) {
      setCanonicalUrl(canonicalUrl);
    }

    // クリーンアップ関数
    return () => {
      clearMetaTags();
    };
  }, [title, description, ogp, twitterCard, canonicalUrl, keywords]);
};

